export async function fetchAppSettings() {
    try {
        const response = await fetch('/api/app-settings');
        if (!response.ok) {
            throw new Error('Failed to fetch settings');
        }
        return await response.json();
    } catch (error) {
        console.error(error);
        return null;
    }
}
